// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"161":"aeb30847","179":"850bbebc","612":"06e2c1bd","677":"8c47345d","942":"2ebbe1c2"}[chunkId] + ".js";
};